<template>
	<div class="pb15">
		<!-- Headline -->
		<div class="xs-12 fw7 fs5 lh125 mb1">{{ $t("create_identity") }}</div>
		<div class="mb8 c6 lh150">
			{{ $t("create_identity_for_entity") }}
			<span class="fw7">{{ entityName }}</span>:
		</div>

		<!-- Fields -->
		<div class="mb4">
			<core-form-input
				class="mb2"
				componentName="j-base-input-text"
				:name="$t('type')"
				:label="$t('type')"
				v-model="form.type"
			/>
			<core-form-input
				componentName="j-base-input-text"
				:name="$t('value')"
				:label="$t('value')"
				v-model="form.value"
			/>
		</div>

		<!-- Buttons -->
		<div class="xs-12 flex xs-between mt6">
			<j-button @click="createIdentity" :isLoading="isLoading">
				{{
				$t("create")
				}}
			</j-button>
			<j-button type="bordered" @click="$emit('cancel')">
				{{
				$t("cancel")
				}}
			</j-button>
		</div>
	</div>
</template>

<script>
/**
 * This component should eventually come from CMS
 * Every tenant would have their own component for address creation with fields they want to have there
 * This one is suited to AEG
 */
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: { CoreFormInput, JButton },

	props: {
		entityId: {
			type: String
		},

		entityName: {
			type: String,
			default: ""
		},

		/**
		 * Instructions for creation of a new fact
		 * What properties it can included is in docs
		 */
		createOptions: {
			type: Object
		}
	},

	data() {
		return {
			isLoading: false,

			// Will be populated based on schema
			form: {}
		}
	},

	methods: {
		async createIdentity() {
			const query = gql`
				mutation addIdentity($entityId: String!, $input: addIdentityInput!) {
					addIdentity(entityId: $entityId, identityInput: $input) {
						errors
						status
						createdStatus {
							id
						}
					}
				}
			`

			this.isLoading = true
			const res = await api({
				query,
				variables: {
					entityId: this.entityId,
					input: {
						...this.form
					}
				}
			})

			if (res?.data?.addIdentity?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.addIdentity?.errors?.[0] || this.$t("errors.general")
				)
				this.isLoading = false
				return
			}

			// Success
			this.isLoading = false
			this.form = {} // Reset form
			this.$emit("identity:created", res?.data?.addIdentity?.createdStatus?.id)
		}
	},

	watch: {
		createOptions: {
			handler() {
				this.form["type"] = this.createOptions?.type
			},
			deep: true,
			immediate: true
		}
	}
}
</script>
